import React, { Component } from 'react'
import { connect } from 'react-redux'


import {
    BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import { Col, Row } from 'antd';


const colors = ["#321fdb", "#2982cc", "#f9b115", "#e55353", "#f4953f", "#2eb85c", "#ab43b8", "#da6b6b", "#43b8b3"]

class BieuDoCot extends Component {
    constructor(props) {
        super(props);
        const { functions } = props;
        this.state = {
            data_bieudo: [],
            key: []
        };

    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { data } = this.props
        if (prevProps.data !== data) {
            this.setState({ data_bieudo: data, key: this.getKeys(data) })
        }
    }
    getKeys(data) {
        var keys = []
        if (data && data[0]) Object.keys(data[0]).map(key => { if (key !== 'năm') keys.push(key) })
        return keys
    }



    render() {
        const { data_bieudo, key } = this.state

        return (


            <ResponsiveContainer >
                <BarChart
                    data={data_bieudo}
                    margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="năm" />
                    <YAxis />
                    <Tooltip />
                    <Legend layout="vertical" />

                    {key.map((value, idx) =>
                        <Bar dataKey={value} name={String(value).charAt(0).toUpperCase() + String(value).slice(1)} stackId="a" fill={colors[idx]}
                        />)}

                </BarChart>
            </ResponsiveContainer>

        )
    }
};
const mapPropsToState = (state) => ({ user: state.oidc.user });
export default connect(mapPropsToState)(BieuDoCot)